'use es6';

/* global LayoutBuilderUI */
import { OPEN_FILE_MANAGER, CLOSE_FILE_MANAGER, OPEN_MODAL, CLOSE_MODAL, SET_USER_ATTRIBUTE, EDITOR_INITIALIZED, WAIT_FOR_SIDEBAR_IFRAME_LOADED, SET_HUB_SETTING } from 'EmailEditorUI/dragDropMessageTypes';
function callbackIfResp(callback) {
  return resp => {
    if (resp) {
      callback(resp);
    }
  };
}
export function openFileManager(options, callback) {
  return LayoutBuilderUI.messenger.postMessage(OPEN_FILE_MANAGER, options, callbackIfResp(callback));
}
export function closeFileManager(options, callback) {
  return LayoutBuilderUI.messenger.postMessage(CLOSE_FILE_MANAGER, options, callbackIfResp(callback));
}
export function openModal(modalType, modalMetadata, callback) {
  return LayoutBuilderUI.messenger.postMessage(OPEN_MODAL, {
    modalType,
    modalMetadata
  }, callbackIfResp(callback));
}
export function closeModal(options, callback) {
  return LayoutBuilderUI.messenger.postMessage(CLOSE_MODAL, options, callbackIfResp(callback));
}
export function setUserAttribute({
  attribute,
  value
}) {
  return LayoutBuilderUI.messenger.postMessage(SET_USER_ATTRIBUTE, {
    attribute,
    value
  });
}
export function setHubSetting({
  key,
  value,
  isTemplateEditor
}) {
  return LayoutBuilderUI.messenger.postMessage(SET_HUB_SETTING, {
    key,
    value,
    isTemplateEditor
  });
}
export function editorInitialized(renderedModules) {
  return LayoutBuilderUI.messenger.postMessage(EDITOR_INITIALIZED, {
    queuedInpageLifecycleTimestamps: window.hsQueuedLifecycleTimestamps,
    renderedModules
  });
}
export function waitForSidebarIframeLoaded(callback) {
  return LayoutBuilderUI.messenger.postMessage(WAIT_FOR_SIDEBAR_IFRAME_LOADED, {}, callbackIfResp(callback));
}